import React from "react";
import { MapPin, Phone, Mail } from "lucide-react";

const offices = [
  {
    id: 1,
    name: "Head Office",
    address: "600 Matheson Blvd W, Unit 5 Inside Venture X, Mississauga, ON, L5R 4B8.",
    phone: "+1 (437) 286 3002",
    email: "info@newwaysecurity.com",
  }
];

export default function Location() {
  return (
    <div className="min-h-screen text-gray-800">
      <div className="text-center py-12">
        <h1 className="text-4xl font-bold text-red-800">Our Locations</h1>
        <p className="mt-2 text-lg text-gray-600">Find us across the globe</p>
      </div>

      <div className="max-w-6xl mx-auto px-4 mb-12">
        {offices.map((office) => (
          <div
            key={office.id}
            className="bg-white shadow-md flex my-6 justify-between rounded-2xl p-6 border border-red-800"
          >
            <div className="flex items-center justify-center">
              <h2 className="text-2xl font-semibold text-red-800 mb-2">
                {office.name}
              </h2>
            </div>
            <div className="flex flex-col items-flex-start justify-center">
              <p className="flex items-start text-gray-700">
                <MapPin className="mt-1 text-red-800 w-5 h-5 mr-2" />
                {office.address}
              </p>
              <p className="flex items-start text-gray-700 mt-1">
                <Phone className="mt-1 text-red-800 w-5 h-5 mr-2" />
                {office.phone}
              </p>
              <p className="flex items-start text-gray-700 mt-1">
                <Mail className="mt-1 text-red-800 w-5 h-5 mr-2" />
                {office.email}
              </p>
            </div>
            <div className="flex items-center justify-center">
              <a
                href="/contact"
                className="inline-block px-6 py-3 text-white bg-red-800 rounded-2xl shadow hover:bg-red-900 transition-colors duration-200 font-semibold"
              >
                Get a Quote
              </a>
            </div>
          </div>
        ))}
      </div>

      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-2xl font-bold text-red-800 mb-4">Map</h2>
        <div className="bg-red-200 rounded-2xl shadow-md">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2888.7456257558338!2d-79.68962222344686!3d43.61183775510457!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b417bd6d1ea21%3A0x25fc4fd63792915b!2sNew%20Way%20Security!5e0!3m2!1sen!2sin!4v1755714549463!5m2!1sen!2sin"
            width="100%"
            height="450"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </div>
  );
}
